import { CashFlowSourceEnum } from '@/services/api-clients';
import i18n from '@/i18n/config';
import { LF } from '@/i18n/LF';
export function cashFlowSourceNameFilter(source: CashFlowSourceEnum) {
  switch(source) {
    case CashFlowSourceEnum.Settlement: return i18n.t(LF.Settlement) as string;
    case CashFlowSourceEnum.Payoff: return i18n.t(LF.Payoff) as string;
    case CashFlowSourceEnum.CashFlow: return i18n.t(LF.CashFlow) as string;
    default: return '';
  }
}
